<template>
  <div class="d-flex flex-row" style="width: 100%">
    <div class="cell-content">
      <div v-if="showSummary">
        <div v-if="voicemail.transcriptionSummary" class="ml-1">
          <span class="primary-text">{{ voicemail.transcriptionSummary }}</span>
        </div>
        <v-chip small v-if="showCategory" :style="{ 'pointer-events': 'none' }">{{ voicemail.transcriptionCategory }}</v-chip>
      </div>
      <div v-else>
        <span class="text-caption text--secondary">{{ $t('vmail.tip.noSummary') }}</span>
      </div>
    </div>
    <v-spacer />
    <div class="d-flex flex-row-reverse" v-if="voicemail.isCustomFolder" style="width: 151px;">
      <div>
        <v-icon class="mr-1" small>mdi-folder</v-icon>
        <span class="text-caption font-weight-light" data-testid="voicemail-folder-name">{{ voicemail.customFolder }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'voicemail-msgs-table-transcription-column',
  props: {
    voicemail: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      vmbox: 'voicemails/vmboxSettings'
    }),
    summaryEnabled () {
      return this.vmbox?.summarize
    },
    categoryEnabled () {
      return this.vmbox?.categorize
    },
    showCategory () {
      return this.categoryEnabled && this.voicemail.transcriptionCategory
    },
    showSummary () {
      return this.summaryEnabled && this.voicemail.transcriptionSummary
    }
  }
}
</script>

<style scoped>
</style>
